<span class="sr-only label">{{ filter()?.label }}</span>

<ul class="py-2 featured-filter-list">
  @for (f of filterItems(); track f.id) {
    <li class="featured-filter-list__item">
      <a
        class="featured-filter"
        [routerLink]="['.']"
        [queryParams]="filterParam(f.id)"
        queryParamsHandling="merge"
        [class.is--active]="activeQueryParam() === f.id"
      >
        <figure class="bg-gray-100 featured-filter__figure">
          @if (f?.image || f?.swatch?.image) {
            <img class="featured-filter__figure__image" [src]="f.image?.image?.src || f.swatch?.image?.image?.w_350" alt="{{ f.label }}" />
          }
        </figure>
        <span class="featured-filter__label label fs-body-sm">{{ f?.label }}</span>

        @if (activeQueryParam() === f.id) {
          <span class="button__floating-chip chip chip--xxs">
            <app-icon class="icon-xxxs" anchor="icon-close-xxs"></app-icon>
          </span>
        }
      </a>
    </li>
  }
</ul>
